/**
 * 字体状态同步现已由 scripts/patch-univer-font-family-toolbar.cjs
 * 直接接入 Univer 原生 value$。保留这两个导出，兼容 main.ts 现有调用。
 *
 * 不再重放 sheet.operation.set-selections；该旧做法会在富文本字体命令后
 * 重新读取单元格级字体，并把正确显示覆盖成 Arial。
 */
export const installUniverFontFamilyDisplayPatch = () => undefined

export const uninstallUniverFontFamilyDisplayPatch = () => undefined
